import { getCoverageLineConfig } from '@common/config';
import { flatten, uniq } from 'lodash';
import { useEffect } from 'react';
import { CoverageLine } from 'enums';
import { CarrierSubmissionSearchItem } from 'types';
import { HotjarEvents } from 'utils/hotjar-events';
import useSubmissionFilter from 'broker/components/SubmissionsView/useSubmissionFilter';
import { queueStorageKeys } from './config';

interface UseCoverageLineFilterProps {
  items: CarrierSubmissionSearchItem[];
  areItemsLoaded: boolean;
  paginationReset: () => void;
}

export function useCoverageLineFilter({ items, areItemsLoaded, paginationReset }: UseCoverageLineFilterProps) {
  const coverageLineFilter = useSubmissionFilter({
    baseFiltersList: [],
    storageKey: queueStorageKeys.coverageLine,
    hotjarEvent: HotjarEvents.SubmissionsCoverageLineFilter,
    paginationReset,
  });

  const setCoverageLineFilters = coverageLineFilter.setFilters;

  useEffect(() => {
    if (!areItemsLoaded || items.length === 0) {
      return;
    }

    const coverageLines = uniq(flatten(items.map(({ submission }) => submission?.coverageLines || []))).sort((a, b) =>
      a.localeCompare(b),
    );

    setCoverageLineFilters((prev) =>
      coverageLines.map((cl) => ({
        key: cl,
        checked: prev.find((f) => f.key === cl)?.checked ?? false,
        label: getCoverageLineConfig(cl as CoverageLine).text,
      })),
    );
  }, [areItemsLoaded, items, setCoverageLineFilters]);

  return coverageLineFilter;
}
